// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  dbVersion: 8,
  production: false,
  client: 'Web',
  clientVersion: 1,
  apiUrl: 'https://vikingassistance-api-play.azurewebsites.net',
  blobUrl: 'https://vikingassistanceplay.blob.core.windows.net',
  acceptHeader: 'application/vnd.viking.v' + 1 + '+json',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
